import { css, Theme } from '@emotion/react'
import { buttonClasses } from '@mui/material'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  max-width: 1142px;
  padding: ${theme.spacing(3)};
`

export const headerSection = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${theme.spacing(4)};
`

export const header = (theme: Theme) => css`
  padding: ${theme.spacing(1, 0)};

  font-weight: 700;
`

export const addContentLnk = css`
  text-decoration: none;
`

export const form = css`
  margin: 0 auto;
  max-width: 754px;
`

export const field = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`

export const actionButtons = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(2)};
`

export const actionButton = () => css`
  flex: 1;
`

export const cancelButton = (theme: Theme) => css`
  &.${buttonClasses.root} {
    color: ${theme.colors.red};

    :active {
      color: ${theme.colors.red};
    }
  }
`
